mutation ResendCharityContactInvite($input: ResendCharityContactInviteInput!) {
  resendCharityContactInvite(input: $input) {
    success
  }
}
